import { useState } from "react";
import { Get, Set } from "../../../../../Request";
export const useClassList = () => {
  const [loading, setLoading] = useState({
    list: true,
  });
  const [data, setData] = useState({});
  const [showModal, setShowModal] = useState({
    status: false,
    name: "",
  });
  const getData = async () => {
    setLoading({ ...loading, list: true });
    Get({
      url: "/classmanager/class_list",
    }).then(res => {
      setLoading({ ...loading, list: false });
      setData(res);
    });
  };
  return { loading, getData, data, showModal, setShowModal };
};

export const useAthletes = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const getData = async class_id => {
    setLoading(true);
    Get({
      url: "/joinclass/class_id",
      data: { class_id },
    }).then(res => {
      setData(res);
      setLoading(false);
    });
  };
  return { loading, getData, data };
};

export const useClassInfoEdit = () => {
  const [loading, setLoading] = useState(false);
  const FormSubmit = data => {
    setLoading(true);
    Set({
      url: "/classmanager/update_details",
      data: data,
    }).then(() => {
      setLoading(false);
    });
  };
  return { loading, FormSubmit };
};
//

export const useTeacherUpdate = () => {
  const [loading, setLoading] = useState();
  const formSubmit = data => {
    setLoading(true);
    Set({
      url: "/classmanager/update_teachers",
      data: data,
    }).then(() => {
      setLoading(false);
    });
  };
  return { formSubmit, loading };
};

export const useAddTeacher = () => {
  const [loading, setLoading] = useState();
  const sendForm = data => {
    setLoading(true);
    Set({
      url: "/classmanager/update_teachers",
      data: data,
    }).then(() => {
      setLoading(false);
    });
  };
  return { loading, sendForm };
};
export const useTag = () => {
  const [loadding, setLoading] = useState();
  const [tags, setTags] = useState();
  const getTag = () => {
    setLoading(true);
    Get({
      url: "/tag/show_list",
    }).then(res => {
      setTags(res);
      setLoading(false);
    });
  };
  return { loadding, tags, getTag };
};
export const useSingleData = id => {
  const [loading, setLoading] = useState(true);
  const [Data, setData] = useState({});
  const [loadingTeacher, setLoadingTeacher] = useState(false);
  const getData = slug => {
    setLoading(true);
    Get({
      url: "/class/single",
      data: {
        slug,
      },
    }).then(res => {
      setLoading(false);

      setData(res);
    });
  };
  const updateTeachers = async data => {
    setLoadingTeacher(true);
    Set({
      url: "/class/update_teachers",
      data: { ...data, ...{ class_id: id } },
    }).then(res => {
      setLoadingTeacher(false);
    });
  };
  return { Data, loading, getData, updateTeachers };
};
export const useEditClass = id => {
  const [loading, setloading] = useState(false);
  const [step, setstep] = useState(1);
  const [Data, setData] = useState([]);
  const formSubmit = async data => {
    setloading(true);
    Set({
      url: "/classmanager/update_details",
      data: { ...data, ...{ class_id: id } },
    }).then(res => {
      setstep(1);
      setloading(false);
    });
  };
  const updateTeachers = async data => {
    setloading(true);
    Set({
      url: "/classmanager/update_teachers",
      data: { ...data, ...{ class_id: id } },
    }).then(res => {
      setstep(1);
      setloading(false);
    });
  };
  const deleteClass = async data => {
    setloading(true);
    Set({
      url: "/classmanager/destroy_class",
      data: { ...{ class_id: id } },
    }).then(res => {
      // history.goBack();
      setloading(false);
    });
  };
  const getTag = () => {
    setloading(true);

    Get({
      url: "/tag/show_list",
    }).then(res => {
      setData(res);
      return res;
    });
  };

  return {
    formSubmit,
    Data,
    loading,
    getTag,
    updateTeachers,
    step,
    setstep,
    deleteClass,
  };
};
